export function getNonOverlappingPosition(desiredPosition, allModules, axis = 'z', step = 3) {
  let pos = { ...desiredPosition };
  let isOverlapping = true;
  while (isOverlapping) {
    isOverlapping = allModules.some((mod) => {
      if (!mod.data || !mod.data.position) return false;
      return mod.data.position.x === pos.x && mod.data.position.y === pos.y && mod.data.position.z === pos.z;
    });
    if (isOverlapping) pos[axis] += step;
  }
  return pos;
}
